var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pt=='wx')?_c('div',{staticClass:"ycxf"},[_c('router-link',{attrs:{"to":_vm.data.url}},[_c('img',{attrs:{"src":_vm.data.pic,"alt":""}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }